<template>
  <div class="img-framework-logo">
    <img :src="`${$STATIC_PATH}/img/framework.gif`" alt="Framework for Great Schools circles"/>
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
})
export default class ImgFrameworkLogo extends Vue {
}
</script>

<style lang="scss">
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.img-framework-logo {
  > img {
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ImgFrameworkLogo.vue